// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3d0ZL","content":"LoadingAlert_content__3mWCj"};